import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { IntermediaryDto } from '../../model/business/IntermediaryDto';

@Component({
  selector: 'app-intermediary-component',
  templateUrl: './intermediary-component.html',
  styleUrls: ['./intermediary-component.css'],
})
export class IntermediaryComponent implements OnInit {
  @Input('form')
  formGroup: FormGroup;
  intermediaryStore: IntermediaryDto;

  constructor(
    private cdref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.intermediaryStore = new IntermediaryDto();
  }

  public get intermediary(): IntermediaryDto {
    return this.intermediaryStore;
  }
}
